export const manifest = {
    bundles: [
        {
            name: 'common',
            assets: [
                {
                    alias: 'cancel',
                    src: '/images/cancel.png',
                },
                {
                    alias: 'clean',
                    src: '/images/clean.png',
                },
                {
                    alias: 'submit',
                    src: '/images/submit.png',
                },
                {
                    alias: 'palette',
                    src: '/images/palette.png',
                },
                {
                    alias: 'dropper',
                    src: '/images/dropper.png',
                },
                {
                    alias: 'edit',
                    src: '/images/edit.svg',
                },
                {
                    alias: 'cart2',
                    src: '/images/cart2.svg',
                },
            ]
        }
    ]
}